<template>
  <div class="page">
    <header>
      <div class="header-title">临时授权管理-{{ bindName }}</div>
      <div @click="add">
        <img src="../../assets/add.png" alt="" />
        <div>新增授权</div>
      </div>
    </header>

    <div class="line"></div>

    <main>
      <div class="sec-select">
        <div class="sec-select-1">
          <el-select value="" v-model="state">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
          <el-input
                  v-model="nameOrPhone"
            style="width: 180px; margin-left: 22px; margin-right: 6px"
            placeholder="姓名或手机号"
          ></el-input>
          <el-button @click="searchPage">搜索</el-button>
        </div>
        <!--        <div>-->
        <!--          <el-select value=""></el-select>-->
        <!--        </div>-->
      </div>

      <el-table height="40vh" :data="listData">
        <el-table-column prop="authUserName" label="姓名" align="center">
        </el-table-column>
        <el-table-column prop="authUserPhone" label="手机号" align="center">
        </el-table-column>
        <el-table-column prop="validStartStr" label="开始时间" align="center" width="160">
        </el-table-column>
        <el-table-column prop="validEndStr" label="结束时间" align="center" width="160">
        </el-table-column>
        <el-table-column prop="mac" label="授权次数" align="center">
          <template slot-scope="scope">
            <div>
              {{ scope.row.authTimes === 0 ? "无限次" : scope.row.authTimes }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="usedTimes" label="已使用次数" align="center">
        </el-table-column>
        <el-table-column prop="opUserName" label="操作员" align="center">
        </el-table-column>
        <el-table-column prop="opUserPhone" label="操作员电话" align="center">
        </el-table-column>
        <el-table-column prop="state" label="状态" align="center">
        </el-table-column>
        <el-table-column prop="mac" label="操作" align="center" width="160">
          <template slot-scope="scope">
            <el-button
              type="primary"
              plain
              size="mini"
              @click="change(scope.row)"
              >编辑</el-button
            >
            <el-button
              type="danger"
              plain
              size="mini"
              @click="deleteItem(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="sec-select">
        <div></div>
        <el-pagination
          @current-change="changePage"
          :current-page="pageIdx + 1"
          :page-size="10"
          layout="total, prev, pager, next, jumper"
          :total="itemTotal"
        >
        </el-pagination>
      </div>
    </main>

    <el-dialog
      append-to-body
      :modal-append-to-body="false"
      :title="dialogInput.dialogTitle"
      :close-on-click-modal="false"
      :visible.sync="dialogFormVisible"
    >
      <div class="dialog-main">
        <div class="r-l">
          <div class="r-l-name">用户姓名：</div>
          <el-input
            autocomplete="off"
            v-model="dialogInput.authUserName"
          ></el-input>
        </div>

        <div class="r-l">
          <div class="r-l-name">手机号：</div>
          <el-input
            autocomplete="off"
            :disabled="dialogInput.dialogTitle === '编辑授权'"
            v-model="dialogInput.authUserPhone"
          ></el-input>
        </div>

        <div class="r-l">
          <div class="r-l-name">授权次数：</div>
          <el-select
            placeholder="请选择活动区域"
            value=""
            v-model="dialogInput.authTimesType"
          >
            <el-option label="无限次" value="0"></el-option>
            <el-option label="有限次数" value="1"></el-option>
          </el-select>
        </div>

        <div class="r-l" v-if="dialogInput.authTimesType === '1'">
          <div class="r-l-name">设置次数：</div>
          <el-input
            autocomplete="off"
            v-model="dialogInput.authTimes"
          ></el-input>
        </div>

        <div class="r-l">
          <div class="r-l-name">生效时段：</div>
          <el-date-picker
            v-model="dialogInput.time"
            type="datetimerange"
            range-separator="~"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </div>

        <div class="r-l" v-if="bindType === '门禁'">
          <div class="r-l-name">继电器ID：</div>
          <el-input
            autocomplete="off"
            v-model="dialogInput.authUserPhone"
          ></el-input>
        </div>

        <div class="r-l" v-if="bindType === '门禁'">
          <div class="r-l-name">继电器延时：</div>
          <el-input
            autocomplete="off"
            v-model="dialogInput.authUserPhone"
          ></el-input>
        </div>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="opSelect">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
/* eslint-disable no-console */

import axios from "axios";
import Utils from "../../Utils.js";
import { Message } from "element-ui";
import { MessageBox } from "element-ui";
import { Loading } from "element-ui";

export default {
  name: "auth",

  props: {
    bindId: String,
    devId: String,
    bindName: String
  },

  data() {
    return {
      state: "", //查询状态

      pageIdx: 0,
      itemTotal: 0,

      bindType: "区域",

      listData: [],
      nameOrPhone: "",

      dialogFormVisible: false,

      options: [
        {
          value: "",
          label: "全部状态"
        },
        {
          value: "生效中",
          label: "生效中"
        },
        {
          value: "未生效",
          label: "未生效"
        },
        {
          value: "已过期",
          label: "已过期"
        },
        {
          value: "已取消",
          label: "已取消"
        }
      ],

      dialogInput: {
        dialogTitle: "",

        authUserName: "",
        authUserPhone: "",
        time: "",
        relayID: "",
        relayDelay: "",
        authTimes: "",
        authTimesType: "",
        id: ""
      },

      token: ""
    };
  },

  created() {
    this.query();
  },

  watch: {
    state() {
      this.pageIdx = 0;
      this.query();
    }
  },

  methods: {
    //列表查询
    query(isDelete) {
      if (isDelete && this.pageIdx > 0 && this.listData.length === 1) {
        this.pageIdx -= 1;
      }
      let data = {
        devID: this.devId,
        bindID: this.bindId,
        pageSize: 10,
        pageIdx: this.pageIdx,
        nameOrPhone: this.nameOrPhone
      };
      if (this.state !== "") {
        data.state = this.state;
      }

      const loading = Loading.service({
        lock: true,
        text: "加载列表中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.1)"
      });

      axios({
        method: "post",
        url: "tmpkeyauths",
        data: data
      })
        .then(value => {
          this.listData = [];
          this.itemTotal = value.data.total;
          // this.itemTotal = 100;
          if (value && value.data && value.data.data) {
            value.data.data.forEach(data => {
              data.validStartStr = Utils.long2second(data.authStart * 1000);
              data.validEndStr = Utils.long2second(data.authEnd * 1000);
              this.listData.push(data);
            });
          }
        })
        .catch(() => {})
        .finally(() => {
          loading.close();
        });
    },

    opSelect() {
      if (this.dialogInput.id && this.dialogInput.id !== "") {
        this.changeCommit();
      } else {
        this.addCommit();
      }
    },

    //新建弹框
    add() {
      this.dialogInput.dialogTitle = "新增授权";

      this.dialogInput.id = "";
      this.dialogInput.time = "";
      this.dialogInput.authUserName = "";
      this.dialogInput.authUserPhone = "";
      this.dialogInput.authTimesType = "0";
      this.dialogInput.authTimes = 1;
      this.dialogInput.relayID = "";
      this.dialogInput.relayDelay = "";

      this.dialogFormVisible = true;
    },

    //新建提交数据
    addCommit() {
      if (this.dialogInput.authUserName === "") {
        Message.warning("请填写用户姓名");
        return;
      }
      if (this.dialogInput.authUserPhone === "") {
        Message.warning("请填写电话号码");
        return;
      }
      if (this.dialogInput.authTimesType === "0") {
        this.dialogInput.authTimes = 0;
      } else if (!parseInt(this.dialogInput.authTimes)) {
        Message.warning("请输入正确的次数");
        return;
      } else if (parseInt(this.dialogInput.authTimes) < 1) {
        Message.warning("请输入正确的次数");
        return;
      }
      if (this.dialogInput.time === "") {
        Message.warning("请选择生效时段");
        return;
      }
      let data = {
        authUserName: this.dialogInput.authUserName,
        authUserPhone: this.dialogInput.authUserPhone,
        content: this.dialogInput.content,
        authTimes: parseInt(this.dialogInput.authTimes),
        authStart: parseInt(this.dialogInput.time[0].getTime() / 1000),
        authEnd: parseInt(this.dialogInput.time[1].getTime() / 1000),
        bindType: this.bindType,
        devID: this.devId,
        bindID: this.bindId
      };
      if (this.bindType === "门禁") {
        if (this.dialogInput.relayID === "") {
          Message.warning("请输入继电器ID");
          return;
        }
        if (this.dialogInput.relayDelay === "") {
          Message.warning("请输入继电器延时");
          return;
        }
        data.relayID = this.dialogInput.relayID;
        data.relayDelay = this.dialogInput.relayDelay;
      }

      const loading = Loading.service({
        lock: true,
        text: "添加中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.1)"
      });

      axios({
        method: "post",
        url: "/tmpkeyauths/add",
        headers: { Authorization: this.token },
        data: data
      })
        .then(value => {
          if (value.data.code !== 0) {
            Message.error(value.data.message);
          } else {
            this.dialogFormVisible = false;
            Message.success("新授权成功");
            this.query();
          }
        })
        .catch(() => {
          Message.error("新建授权失败");
        })
        .finally(() => {
          loading.close();
        });
    },

    //编辑弹框
    change(data) {
      if (data) {
        this.dialogInput.dialogTitle = "编辑授权";

        this.dialogInput.time = [];
        this.dialogInput.time.push(new Date(data.authStart * 1000));
        this.dialogInput.time.push(new Date(data.authEnd * 1000));

        this.dialogInput.authUserName = data.authUserName;
        this.dialogInput.authUserPhone = data.authUserPhone;
        if (data.authTimes === 0) {
          this.dialogInput.authTimesType = "0";
        } else {
          this.dialogInput.authTimesType = "1";
        }
        this.dialogInput.authTimes = data.authTimes;
        this.dialogInput.relayID = data.relayID;
        this.dialogInput.relayDelay = data.relayDelay;
        this.dialogInput.id = data.id;

        this.dialogFormVisible = true;
      }
    },

    //新建提交数据
    changeCommit() {
      if (this.dialogInput.authUserName === "") {
        Message.warning("请填写用户姓名");
        return;
      }
      if (this.dialogInput.authUserPhone === "") {
        Message.warning("请填写电话号码");
        return;
      }
      if (this.dialogInput.time === "") {
        Message.warning("请选择生效时段");
        return;
      }
      if (this.dialogInput.authTimesType === "0") {
        this.dialogInput.authTimes = 0;
      } else if (!parseInt(this.dialogInput.authTimes)) {
        Message.warning("请输入正确的次数");
        return;
      }
      let data = {
        authUserName: this.dialogInput.authUserName,
        authUserPhone: this.dialogInput.authUserPhone,
        content: this.dialogInput.content,
        authTimes: parseInt(this.dialogInput.authTimes),
        authStart: parseInt(this.dialogInput.time[0].getTime() / 1000),
        authEnd: parseInt(this.dialogInput.time[1].getTime() / 1000),
        bindType: this.bindType,
        devID: this.devId,
        bindID: this.bindId
      };
      if (this.bindType === "门禁") {
        if (this.dialogInput.relayID === "") {
          Message.warning("请输入继电器ID");
          return;
        }
        if (this.dialogInput.relayDelay === "") {
          Message.warning("请输入继电器延时");
          return;
        }
        data.relayID = this.dialogInput.relayID;
        data.relayDelay = this.dialogInput.relayDelay;
      }

      data.id = this.dialogInput.id;

      const loading = Loading.service({
        lock: true,
        text: "编辑中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.1)"
      });

      axios({
        method: "post",
        url: "/tmpkeyauths/edit",
        headers: { Authorization: this.token },
        data: data
      })
        .then(value => {
          if (value.data.code !== 0) {
            Message.error(value.data.message);
          } else {
            this.dialogFormVisible = false;
            Message.success("编辑授权成功");
            this.query();
          }
        })
        .catch(() => {
          Message.error("编辑授权失败");
        })
        .finally(() => {
          loading.close();
        });
    },

    //删除
    deleteItem(data) {
      if (data) {
        MessageBox.confirm(
          "确定删除 " + data.authUserName + " 的临时授权吗?",
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }
        )
          .then(() => {
            const loading = Loading.service({
              lock: true,
              text: "删除中",
              spinner: "el-icon-loading",
              background: "rgba(0, 0, 0, 0.1)"
            });
            axios({
              method: "post",
              url: "tmpkeyauths/delete",
              headers: { Authorization: this.token },
              data: {
                id: data.id,
                devID: this.devId,
                bindID: this.bindId
              }
            })
              .then(value => {
                if (value.data.code === 0) {
                  Message.success("删除成功");
                  this.query(true);
                } else {
                  Message.error(value.data.message);
                }
              })
              .catch(reason => {
                Message.error(reason.toString());
              })
              .finally(() => {
                loading.close();
              });
          })
          .catch(() => {});
      }
    },

    changePage(data) { 
      this.pageIdx = data - 1;
      this.query();
    },

    searchPage() {
      this.pageIdx = 0;
      this.query();
    }
  }
};
</script>

<style lang="scss">
.dialog-main {
  overflow: auto;
  max-height: 400px;
}

.page {
  box-sizing: border-box;
  padding: 10px 20px;
  .line {
    width: 100%;
    height: 1px;
    background: lightgray;
    margin: 15px 0;
  }
  .page-list-none {
    text-align: center;
    img {
      width: 30%;
    }
    margin-top: 120px;
  }
}

header {
  color: #1296db;
  align-items: center;
  box-sizing: border-box;
  display: flex;
  width: 100%;
  justify-content: space-between;
  .header-title {
    font-weight: bold;
  }
  div {
    align-items: center;
    img {
      margin-right: 10px;
      width: 17px;
      height: 17px;
    }
    display: flex;
  }
}

main {
  width: 100%;
  .sec-select {
    margin-top: 12px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .sec-select-1 {
      display: flex;
    }
  }
  .list-group {
    overflow: auto;
    min-height: 460px;
    max-height: 460px;
    .list-group-main {
      padding: 10px 0;
      box-sizing: border-box;
      border: 1px solid lightgray;
    }
  }
  .list {
    width: 98%;
    margin-top: 20px;
    display: flex;
    align-items: center;
    > div {
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .list-0 {
      width: 2%;
    }
    .list-1 {
      width: 10%;
      min-width: 10%;
      max-width: 10%;
    }
    .list-2 {
      width: 20%;
    }
    .list-3 {
      width: 11%;
      img {
        margin: 10px;
        width: 27px;
        height: 27px;
      }
    }
  }
}

.r-l {
  margin-bottom: 20px;
  display: flex;
  width: 100%;
  align-items: center;
  .r-l-name {
    text-align: end;
    width: 120px;
  }
  .el-input,
  .el-textarea,
  .el-date-editor {
    margin-left: 10px;
    width: 400px;
  }
}
</style>
